export default "__VITE_ASSET__DlASg$7j__"